import classNames from 'classnames';
import {connect} from 'react-redux';

import {preventDefault} from 'topmeteo/utils/event';

import {changeIndex} from 'topmeteo/base-image/actionCreators';

const getClassName = ({start, stop, loaded}) => classNames({start, stop, loaded});

const SimpleChunk = ({colSpan, onClick, ...props}) => (
    <td className={getClassName(props)} colSpan={colSpan} onClick={onClick}>
        <span onMouseDown={preventDefault}>&nbsp;</span>
    </td>
);

const mapStateToProps = ({animationStart, animationStop}, {index}) => ({
    start: animationStart === index,
    stop: animationStop === index,
});

const mapDispatchToProps = (dispatch, {index, available}) => ({
    onClick: available ? () => dispatch(changeIndex(index)) : null,
});

export default connect(mapStateToProps, mapDispatchToProps)(SimpleChunk);
